import { render, staticRenderFns } from "./stakeholders-table.vue?vue&type=template&id=50c898d1"
import script from "./stakeholders-table.ts?vue&type=script&lang=js&external"
export * from "./stakeholders-table.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports